import { I18nProvider } from '@lingui/react';
import React from 'react';
import { I18n } from '@lingui/core';
import { Config } from '../config.js';

export type TranslationContextType = Pick<Config, 'texts'>;
export type TranslationContextProps = TranslationContextType & {
    children?: React.ReactNode;
    i18n: I18n;
};
const TranslationContext = React.createContext<TranslationContextType>({
    texts: { brand: 'BRAND', brandUrl: 'BRAND_URL' },
});

export function TranslationContextProvider(props: TranslationContextProps) {
    return (
        <I18nProvider i18n={props.i18n}>
            <TranslationContext.Provider value={{ texts: props.texts }}>
                {props.children}
            </TranslationContext.Provider>
        </I18nProvider>
    );
}

export default TranslationContext;
